import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-border py-14 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-baseline gap-2">
            <span className="font-heading font-black text-xl tracking-tighter">
              GMP<span className="text-accent">.</span>
            </span>
            <span className="font-heading font-medium text-sm text-foreground/80">Développement</span>
          </div>
          <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
            Solutions digitales modernes pour booster la notoriété des marques
            et des commerces. Technologie interne, accompagnement humain.
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground mb-4">Navigation</p>
          <ul className="space-y-3 text-sm">
            <li><a href="/#solutions" className="text-foreground/70 hover:text-accent transition-colors">Solutions</a></li>
            <li><a href="/#tarifs" className="text-foreground/70 hover:text-accent transition-colors">Tarifs</a></li>
            <li><Link to="/blog" className="text-foreground/70 hover:text-warm transition-colors">Blog</Link></li>
            <li><a href="/#contact" className="text-foreground/70 hover:text-accent transition-colors">Contact</a></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground mb-4">Contact</p>
          <a
            href="mailto:Gmpdeveloppement@gmail.com"
            className="inline-flex items-center gap-2 text-sm text-foreground/70 hover:text-accent transition-colors"
          >
            <Mail size={16} /> Gmpdeveloppement@gmail.com
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-6 border-t border-border flex flex-col sm:flex-row justify-between gap-4 text-xs text-muted-foreground">
        <p>© {new Date().getFullYear()} GMP Développement. Tous droits réservés.</p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-accent transition-colors">
          Espace admin
        </Link>
      </div>
    </footer>
  );
};
